import { connect } from 'react-redux';
import RetryFetchButton from './RetryFetchButton';

const mapDispatchToState = (dispatch, props) => ({
    retry: () => dispatch( props.action() )
})

export default connect(null, mapDispatchToState)(RetryFetchButton);